import { useQueryClient } from '@tanstack/react-query';

import { AppError } from '@/utils';

import { usersQueryKeys } from '../data';
import { UserProfile } from '../types';

export const useUserInfo = (): UserProfile => {
  const queryClient = useQueryClient();

  const userInfo = queryClient.getQueryData<UserProfile>(
    usersQueryKeys.getUserProfile,
  );

  if (!userInfo) throw AppError.authError();

  return userInfo;
};
